import React from "react";
import {FieldViewProps} from "../../../../../render/view";
import WorkdayDurations from "../../../../../../gd-components/workday-durations/workday-durations";


export default function FieldCompanyUserWorkSchedule_View(props:FieldViewProps) {


    return (
        <WorkdayDurations model={props.model}/>
    )
}
